import { render, staticRenderFns } from "./ApplicationsTab.vue?vue&type=template&id=30c70750&scoped=true&"
import script from "./ApplicationsTab.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ApplicationsTab.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ApplicationsTab.vue?vue&type=style&index=0&id=30c70750&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c70750",
  null
  
)

export default component.exports